import { render, staticRenderFns } from "./shipmentDisplaySearch.vue?vue&type=template&id=2f8c66dc&scoped=true"
import script from "./shipmentDisplaySearch.vue?vue&type=script&lang=js"
export * from "./shipmentDisplaySearch.vue?vue&type=script&lang=js"
import style0 from "./shipmentDisplaySearch.vue?vue&type=style&index=0&id=2f8c66dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c66dc",
  null
  
)

export default component.exports